export default __webpack_public_path__ + "static/media/arrow-right-white.2f1e76d4.svg";